angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.sellerPublicationRequestsWidgetController', ['$scope', 'platformWebApp.bladeNavigationService', 'virtoCommerce.marketplaceModule.webApi',
        function ($scope, bladeNavigationService, marketplaceApi) {
            var sellerId = $scope.widget.blade.currentEntity.id;

            function refresh() {
                var searchCriteria = {
                    searchFromAllSellers: false,
                    sellerId: sellerId,
                    skip: 0,
                    take: 0
                };

                marketplaceApi.listitemssearch(searchCriteria, function(data) {
                    $scope.publicationRequestsCount = data.totalCount;
                });
            }

            $scope.openBlade = function () {
                var blade = {
                    id: 'seller-publication-requests-list',
                    title: 'marketplace.blades.seller-publication-request-list.title',
                    subtitle: 'marketplace.blades.seller-publication-request-list.subtitle',
                    breadcrumbs: [],
                    searchCriteria: { searchFromAllSellers: false, sellerId: sellerId },
                    parentWidgetRefresh: refresh,
                    controller: 'virtoCommerce.marketplaceModule.sellerPublicationRequestListController',
                    template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/seller-publication-request-list.tpl.html'
                };
                bladeNavigationService.showBlade(blade, $scope.widget.blade);
            };

            refresh();
        }
]);
